import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

export const functionalityApi = createApi({
  reducerPath: "functionalityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "http://subactiv.sytes.net:1337/api/",
    tagTypes: ["functionalities"],
    prepareHeaders: (headers, { getState }) => {
      const token =
        "8c4a7ecf9805fa82b0db77d3eeadca211fe136bd21761de9d621a05949b31bca5cc32f90aff18db5f6540b3744b6f59ad8bcdcfd1da5c06c5ed58cf4e20ab209ffb30a5e122cd0f5023968320b87c6ce9a3e2b0db4108ec8519cc9ae0ea3e5393fd73614db3242ee9a00b4cc24adc2aade73048ef6f78d69d3cc6818adeff3bb";
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getFunctionalities: build.query({
      query: (param) => `functionalities`,
      providesTags: ["functionalities"],
    }),
  }),
});

export const { useGetFunctionalitiesQuery } = functionalityApi;
